import React, {FC, useEffect, useState} from "react";

import {Arc, Canvas, Line, Rect, Text, RenderObjectTypes, EventRenderObject} from "./lib";
import {CreateRectModal, RectState} from "./components/CreateRectModal";
import {CreateLineModal, LineState} from "./components/CreateLineModal";
import {ArcState, CreateArcModal} from "./components/CreateArcModal";
import {CreateTextModal, TextState} from "./components/CreateTextModal";
import ControlsSelector from "./components/ControlsSelector";

const App: FC = () => {
    const [objects, setObjects] = useState<Array<RectState | LineState | ArcState | TextState>>([]);
    const [selectedObjectIndex, selectObject] = useState<number>();
    const [createModal, setCreateModal] = useState("");
    const onSelect = (index: number, canvasObject: EventRenderObject) => {
        selectObject(index);
        console.log(canvasObject);
    };
    const onModifyObject = (object: object) => {
        if (selectedObjectIndex !== undefined) {
            const cloneObjects = [...objects];
            const selectedObject = cloneObjects[selectedObjectIndex];
            cloneObjects[selectedObjectIndex] = {...selectedObject, ...object};
            setObjects(cloneObjects);
        }
    };
    const onCreate = (object: RectState | LineState | ArcState | TextState) => {
        setObjects([...objects, object]);
    };
    const hideModal = () => setCreateModal("");
    const onHideControls = () => selectObject(undefined);
    const selectedObject = selectedObjectIndex !== undefined ? objects[selectedObjectIndex] : null;
    useEffect(() => {
        if (createModal) {
            selectObject(undefined);
        }
    }, [createModal]);
    return (
        <div className="app">
            <h1>React-Canva</h1>
            <div className="app-buttons">
                <button onClick={() => setCreateModal(RenderObjectTypes.RECT)}>Add Rect</button>
                <button onClick={() => setCreateModal(RenderObjectTypes.LINE)}>Add Line</button>
                <button onClick={() => setCreateModal(RenderObjectTypes.ARC)}>Add Arc</button>
                <button onClick={() => setCreateModal(RenderObjectTypes.TEXT)}>Add Text</button>
            </div>
            {createModal === RenderObjectTypes.RECT && (
                <CreateRectModal onCreate={onCreate} onHide={hideModal}/>
            )}
            {createModal === RenderObjectTypes.LINE && (
                <CreateLineModal onCreate={onCreate} onHide={hideModal}/>
            )}
            {createModal === RenderObjectTypes.ARC && (
                <CreateArcModal onCreate={onCreate} onHide={hideModal}/>
            )}
            {createModal === RenderObjectTypes.TEXT && (
                <CreateTextModal onCreate={onCreate} onHide={hideModal}/>
            )}
            {selectedObject && (
                <ControlsSelector object={selectedObject}
                                  onModifyObject={onModifyObject}
                                  onHide={onHideControls}/>
            )}
            <div className="canvas">
                <Canvas>
                    {objects.map((object, index) => {
                        switch (object.type) {
                            case RenderObjectTypes.RECT:
                                return (
                                    <Rect x={object.x}
                                          y={object.y}
                                          width={object.width}
                                          height={object.height}
                                          onClick={o => onSelect(index, o)}
                                          onContextMenu={o => onSelect(index, o)}
                                          onDoubleClick={o => onSelect(index, o)}
                                          onMouseDown={o => onSelect(index, o)}
                                          onMouseMove={o => onSelect(index, o)}
                                          onMouseUp={o => onSelect(index, o)}
                                          onPointerDown={o => onSelect(index, o)}
                                          fill={object.fill}
                                          stroke={selectedObjectIndex === index ? "#ff0015" : ""}/>
                                );
                            case RenderObjectTypes.LINE:
                                return (
                                    <Line x1={object.x1}
                                          y1={object.y1}
                                          x2={object.x2}
                                          y2={object.y2}
                                          onClick={o => onSelect(index, o)}
                                          fill={object.fill}
                                          stroke={selectedObjectIndex === index ? "#ff0015" : ""}/>
                                );
                            case RenderObjectTypes.ARC:
                                return (
                                    <Arc x={object.x}
                                         y={object.y}
                                         radius={object.radius}
                                         startAngle={object.startAngle}
                                         endAngle={object.endAngle}
                                         onClick={o => onSelect(index, o)}
                                         fill={object.fill}
                                         stroke={selectedObjectIndex === index ? "#ff0015" : ""}/>
                                );
                            case RenderObjectTypes.TEXT:
                                return (
                                    <Text x={object.x}
                                          y={object.y}
                                          text={object.text}
                                          font={object.font}
                                          onClick={o => onSelect(index, o)}
                                          fill={object.fill}
                                          stroke={selectedObjectIndex === index ? "#ff0015" : ""}/>
                                );
                            default:
                                return null;
                        }
                    })}
                </Canvas>
            </div>
        </div>
    );
};

export default App;
